<template>
  <div class="gravitation-table-wrap">
    <el-button type="primary" @click="addData" style="float: right; margin-bottom: 8px"
      >新增</el-button
    >
    <el-table
      class="parae-setting-table"
      :data="tableList"
      :max-height="tableMaxHeight"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <el-table-column label="id" prop="id" width="100"></el-table-column>
      <el-table-column label="名称" prop="paraName" width="400"></el-table-column>
      <el-table-column label="key" prop="paraKey" width="400"></el-table-column>
      <el-table-column label="备注" prop="remark"></el-table-column>
      <el-table-column label="操作" prop width="100">
        <template slot-scope="scope">
          <el-button class="edit-btn" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <gravitatiob-dialog ref="gravitationRef" @updateTable="updateTable"></gravitatiob-dialog>
  </div>
</template>

<script>
import gravitatiobDialog from "./gravitationDialog.vue";
import { getGravitationTable } from "@/api/gravitation";
export default {
  name: "paramsetting",
  mounted() {
    this.getGravitationList();
  },
  components: {
    gravitatiobDialog,
  },
  data() {
    return {
      tableList: [],
      formVisible: false,
      tableMaxHeight: window.innerHeight - 150,
      loading: false,
      search: "",
      isNew: false,
    };
  },
  computed: {
    list: function () {
      return this.$store.state.ParamSetting.paramsettingList;
    },
  },
  methods: {
    getGravitationList() {
      getGravitationTable().then((res) => {
        if (res.code === "0000") {
          this.tableList = res.data;
        }
      });
    },
    closeDialogForm(bool) {
      this.formVisible = bool;
    },
    addData() {
      this.$refs.gravitationRef.showModal(true)
      
    },
    handleEdit(row) {
      this.$refs.gravitationRef.showModal(false, row)
    },
    updateTable () {
      this.getGravitationList();
    }
  },
};
</script>
<style lang="less" scoped>
.gravitation-table-wrap {
  height: 100%;
  .top-header {
    text-align: right;
    margin-bottom: 4px;
  }
}
</style>
